// @flow
import React from 'react';
import type { BlocContent } from 'types/NewsletterBloc';

import ContentBloc from 'components/newsletter/blocs/ContentBloc';

type Props = {
  description: Array<BlocContent>,
};

const Description = ({ description }: Props): any => {
  return description.map((blocFigure, index) =>
    <ContentBloc key={index} {...blocFigure} />
  );
};

export default Description;
